export default "__VITE_ASSET__C5TeBU_O__"